export default "__VITE_ASSET__QxT1gwEP__"